module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp1_3016.7b1bf05c.png";